const convert = require("color-convert");

export const handleButtonHover = hexCode => {
  const hsl = convert.hex.hsl(hexCode);
  return `hsl(${hsl[0]}, ${hsl[1]}%, ${hsl[2] - 10}%)`;
};
